<!-- 数据报表 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm" ref="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="PLC设备">
                    <el-select v-model="form.device" placeholder="请选择设备" @change="handleChangePLC">
                        <el-option
                            v-for="item in deviceList"
                            :key="item.oid"
                            :label="item.customized_serial+'：'+item.terminal_serial"
                            :disabled="item.dev_type != 4"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间范围">
                    <el-date-picker
                        v-model="form.time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="时间间隔">
                    <el-select v-model="form.timeInterval" placeholder="请选择时间间隔">
                        <el-option
                            v-for="item in timeInterval"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click="onExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-bottom:10px;">
                <el-button :type="setting_type== 1 ? 'success': 'primary'" size="small" @click="handleSetType(1)">压力记录</el-button>
                <el-button :type="setting_type== 2 ? 'success': 'primary'" size="small" @click="handleSetType(2)">温度记录</el-button>
                <el-button :type="setting_type== 3 ? 'success': 'primary'" size="small" @click="handleSetType(3)">设备工况</el-button>
				<!-- <el-button :type="setting_type== 4 ? 'success': 'primary'" size="small" @click="handleSetType(4)">供回水温</el-button> -->
                <el-button :type="setting_type== 10 ? 'success': 'primary'" size="small" @click="handleSetType(10)">电能报表</el-button>
                <el-button :type="setting_type== 11 ? 'success': 'primary'" size="small" @click="handleSetType(11)">流量记录</el-button>
                <el-button :type="setting_type== 12 ? 'success': 'primary'" size="small" @click="handleSetType(12)">能效记录</el-button>
            </div>
        </div>
        <template v-if="tableData.length>0 && !showChart">
            <div>
                <el-table class="exportTable" :data="tableData" stripe :height="maxHeight" border>
                    <el-table-column
                        label="日期"
                        prop="date"
                        >
                    </el-table-column>
                    <el-table-column v-for="v in cols"
                        :key="v.prop"
                        :label="v.label"
                        :prop="v.prop"
                        >
                    </el-table-column>
                </el-table>
            </div>
        </template>

        <div class="echart-box" v-if="showChart">
            <div id="main_t" class="main" ref="myEchart_t" style="width: 100%;height:500px"></div>
        </div>

        <div class="noData" v-if="tableData.length===0">-- 暂无数据 --</div>

        <!-- 设置报表展示数据 -->
        <div class="changeBox" @click="handleChangeChart">
            <span :class="[showChart ? 'iconfont icon-biaoge': 'iconfont icon-zhexiantu']"></span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import echarts from "echarts"
import { getMaxHeigth, FormatUTCDate, FormatDate, FormatPrevDate,FormatNextDate, computedUtil2 } from '@/utils/utils'
import Service from '@/api/Service'
import config from '@/config.js'
import { fmtInt32Byte, fmtDoubleByte }  from '@/utils/HexToSingleBatch.js'

import FileSaver from 'file-saver'
import XLSX from 'xlsx'

const nowDay = FormatDate("yyyy-MM-dd");
const nextDay = FormatNextDate("yyyy-MM-dd");
// const prevDay = FormatPrevDate("yyyy-MM-dd");

const SETTING_TYPE = 1; //  温度配置
const timeInterval = [
                {
                    value: 1,
                    name: '小时'
                },
                {
                    value: 2,
                    name: '天'
                },
                {
                    value: 3,
                    name: '月'
                },
            ]
export default {
    name:  'devicereport',
    data() {
        return {
            form: {
                time: [],
                start_time: nowDay,
                end_time: nextDay,
                device: '',
                collector: '',
                timeInterval: 1,
            },

            collectorList: [], // 集控器列表
            deviceList: [], // 设备列表
            pageConfigList: [],  // 页面变量配置
            plcConfigData: [],  //  plc变量配置
            getPlcCurve: [],    // 变量值

            cols: [],
            tableData: [],
            loading: false,
            index: 0,

            total: 100,
            page_num: 1,
            page_sum: 5,
            maxHeight: 500,

            setting_type: SETTING_TYPE,

            falutMsg: [],

            timeInterval: timeInterval,

            // 曲线
            chart_x: null,

            echartsData: {
                categories: [],
                series: [],
            },

            showChart: false,
        }
    },

    computed: {
        ...mapGetters(["machine"]),
    },

    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();

            
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart_x.dispose();
        this.chart_x = null
    },
    async created() {
        await this.getDeviceList();
    },

    methods: {
        // 获取全部PLC
        async getDeviceList() {
            let params = Object.assign({}, { page_num: 1, page_sum: 40 });
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                this.form.device = list[0].oid;
                await this.getData();
                await this.handleChangePLC(list[0].oid)
            }
        },
        async getData() {
            // 表头
            let list = await Service.getServerRoombypid();
            list = list === 'success' ? [] : list
            if(list.length>0) {
                this.pageConfigList = list;
            }
        },
        // 获取PLC addr配置
        async handleChangePLC(terminal_id) {
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 500,
            }
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.plcConfigData = res.list;
                // 获取设备统计数据
                this.handleSetType(this.setting_type)
            }
        },
        // 获取统计数据
        async getPlcData(setting_type){
            this.tableData = []
            let params = {}
                params.terminal_id = this.form.device
                params.setting_type = setting_type
                params.from = this.form.start_time
                params.to = this.form.end_time
                params.time_interval = this.form.timeInterval

            // 判断时间间隔
            let time = (new Date(this.form.end_time).getTime() - new Date(this.form.start_time).getTime())/1000
            let BOOL = true
            if(this.form.timeInterval === 1 && (time / (60 * 60)) > 60 ) { // 超过60小时
                BOOL = false
            }
            if(this.form.timeInterval === 2 && (time / (60 * 60 * 24)) > 60) {  // 超过60天
                BOOL = false
            }
            if(this.form.timeInterval === 3 && (time / (7 * 60 * 60 * 24)) > 20) { // 超过20周
                BOOL = false
            }
            
            if(!BOOL) {
                 this.$message({
                    type: 'warn',
                    message: '查询条件范围太大，请修改时间间隔或者时间范围！'
                });
                return
            }
            // let res = await Service.getPlcCurve(params);
			let res = await Service.getHistoryReport(params);
            let list = res === "success" ? [] : res
            if(list.length>0) {
                this.tableData = this.formatData(list)
                this.echartsData = this.formatChartData(this.tableData)
                // console.log(this.echartsData);
                if(this.showChart) {
                    this.chartConfig_x(this.echartsData)
                }
            }else{
                this.tableData = this.formatData([])
                this.echartsData = {
                    categories: [],
                    series: [],
                }
                if(this.showChart) {
                    this.chartConfig_x(this.echartsData)
                }
            }
            
        },
        // 格式化表格数据
        formatData(list) {
            if(this.cols.length==0) return [];
            let obj = {}
            // 遍历表头
            this.cols.map(j => {
                let key = j.prop;
                obj[key] = j.addr;
            })
            let arr = [];
			list.map(v=>{
				let newObj = {}
				newObj["date"]=v.symbolic_time
				this.cols.map(j=>{
					var str=JSON.stringify(j.addr)+"_"+JSON.stringify(j.opcode)
					for (const key in v.termianl_data){
						if(str===key){
							newObj[j.prop] = v.termianl_data[key]
						}
					}
					
				})
				arr.push(newObj)
			})
			return arr
            // 遍历后台返回数据  格式化数据
       //      list.map(v => {
       //          let newObj = {}
       //          newObj.date = FormatUTCDate(Date.parse(v.date), date_str);
       //          let data = v.data;
       //          let addr_to_val = {}
       //          for (let i = 0; i < data.length; i++) {
       //              let addr = data[i].addr
       //              addr_to_val[addr] = data[i].val
       //          }
       //          for (const key in obj) {
       //              if (obj.hasOwnProperty(key)) {
       //                  const e = obj[key];
       //                  if(addr_to_val[e] != undefined) {
       //                      // 计算设备工况 
       //                      let addrInfo = this.plcConfigData.filter(v=>v.var_Initial_addr == e)
							// // console.log(addrInfo)
       //                      if(addrInfo[0].bytes == 2) {
       //                          let val1 = addr_to_val[e];
       //                          let val2 = addr_to_val[e+1];
       //                          let val = fmtDoubleByte(val1, val2)
       //                          newObj[key] = computedUtil2(val, addrInfo);
                                
       //                      }else if(addrInfo[0].bytes==3) {
       //                          let val1 = addr_to_val[e];
       //                          let val2 = addr_to_val[e+1];
       //                          let val = fmtInt32Byte(val1, val2)
       //                          newObj[key] = computedUtil2(val, addrInfo);
       //                      }else{
       //                          let val = addr_to_val[e];
       //                          newObj[key] = computedUtil2(val, addrInfo);
       //                      }
       //                  }
       //              }
       //          }
       //          arr.push(newObj);
       //      })
           
        },
         // 格式化曲线数据
        formatChartData(list) {
            if(list.length <= 0) {
                return {
                    categories: [],
                    series: []
                }
            }
            // 遍历表头
            let categories = [];
            let series = [];
            this.cols.map((j,i) => {
                let valueData = []
                list.map(v=>{
                    if(i===0) {
                        categories.push(v.date)
                    }
                    valueData.push(v[j.prop])
                })
                series.push({
                    name: j.label,
                    type: 'line',
                    data: valueData,
                })
            })
            return {
                categories,
                series
            }
        },
        handleChangeChart() {
            this.showChart = !this.showChart
            if(this.showChart) {
                this.$nextTick(()=>{
                    if(!this.chart_x) {
                        this.chart_x = echarts.init(this.$refs.myEchart_t); //这里是为了获得容器所在位置
                    }
                    this.chartConfig_x(this.echartsData)
                })
            }else{
                this.chart_x.dispose();
                this.chart_x = null
            }
        },
        // 曲线
        chartConfig_x(data) {
            let _t = this;
            window.onresize = this.chart_x.resize;
            if(data.categories.length === 0) {
                this.chart_x.clear();
                return
            }
            this.chart_x.clear();
            this.chart_x.setOption({ // 进行相关配置
                title: {
                    text: '',
                    left: 'left',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: data.series.map(v=>{return v.name}),
                    x: 'center',
                    itemGap: 10,
                },
                xAxis: {
                    data: data.categories
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    },
                    splitLine: {
                        show: false
                    }
                },
                toolbox: {
                    left: 'right',
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                // 下发滑块
                dataZoom: [{
                    start: 30,
                    end: 70
                }, {
                    type: 'inside'
                }],
                series: data.series
            })
        },
        handleSetReport() {
            
        },
        handleSetType(type) {
            this.setting_type = type
            let cols = this.pageConfigList.filter(v=>v.setting_type === type && v.terminal_id === this.form.device)
            if(cols.length<=0) {
                this.$message({
                    message: '该设备下未配置报表信息',
                    type: 'warning'
                });
				this.cols=[]
				this.getPlcData(type);
                return
            }
            let arr = JSON.parse(cols[0].setting_data)
            this.cols = arr.filter(v=>v.hidden === undefined || v.hidden === false)
            this.getPlcData(type);
        },
        choseTime(val) {
            // 判断所选时间间隔
            if(val) {
                this.form.start_time = val[0]
                this.form.end_time = val[1]

                // let time = (new Date(val[1]).getTime() - new Date(val[0]).getTime())/1000
                // if(time> 0 && time<= 3 * 60 * 60 ) {
                //     // 查询分钟
                //     this.form.timeInterval = 1
                // }else if(time > (3 * 60 * 60) && time <= (5 * 24 * 60 * 60)) {  //  5天内用小时
                //     // 查询小时
                //     this.form.timeInterval = 1
                // }else if(time>(5 * 24 * 60 * 60) && time <= (30 * 24 * 60 * 60)) {  
                //     // 查询天
                //     this.form.timeInterval = 2
                // }else if(time>(7 * 30 * 24 * 60 * 60) && time <=  (12 * 30 * 24 * 60 * 60)) {
                //     // 查询月
                //     this.form.timeInterval = 3
                // }
            }else{
                this.form.timeInterval = 2
                this.form.start_time = nowDay
                this.form.end_time = nextDay
            }
        },
        // 查询
        onSubmit() {
            this.getPlcData(this.setting_type)
        },
		base64(content) {
			return window.btoa(unescape(encodeURIComponent(content)));
		},
        // 导出
        async onExport() {
			var excelContent = document.getElementsByClassName("exportTable")[0].outerHTML;
			// 		alert(excelContent);
			var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
			excelFile += "<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";
			excelFile += "<body><table width='10%'  border='1'>";
			excelFile += excelContent;
			excelFile += "</table></body>";
			excelFile += "</html>";
			var link = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + this.base64(excelFile);
			var a = document.createElement("a");
			a.download = 'export'+ ".xls";
			a.href = link;
			a.click();
			// var blob = new Blob([document.getElementsByClassName("exportTable")[0].outerHTML], {type: "text/plain;charset=utf-8"});
			// saveAs(blob,  "export.xls");
            // let params = {};
            //     params.terminal_id = this.form.device
            //     params.start_time = this.form.start_time
            //     params.end_time = this.form.end_time
            //     params.timeInterval = this.form.timeInterval
            //     params.export_data = this.fmtExportData();

            // let res = await Service.getPlcExport(params);
            // if(res) {
            //     location.href = config.DEFAULT_FILE_PATH + res
            // }
        },
        fmtExportData(){
            let arr = [];
            this.cols.map(v=>{
                let obj = {}
                if(this.setting_type === 2){
                    obj.unit = 0.1
                }
                if(this.setting_type === 3){
                    obj.unit = 0
                }
                obj.name = v.label;
                obj.addr = v.addr;
                arr.push(obj)
            })
            return JSON.stringify(arr)
        },
        handleSizeChange (val) {
            console.log(`每页 ${val} 条`);
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            console.log(`当前页: ${val}`)
            this.page_num = val
            this.getData()
        },

        fmtConcatArr(list) {
            let newArr = [];
            list.map(v=>{
                let Len = newArr.length;
                let bool = true;
                for (let i = 0; i < Len; i++) {
                    const v1 = newArr[i];
                    if(v.date === v1.date) {
                        v1.data = v1.data.concat(v.data);
                        bool = false;
                    }
                }
                if(bool) {
                    newArr.push(v) 
                } 
            })
            return newArr
        },
    }
}

</script>
<style lang='less' scoped>
.noData{
    line-height: 100px;
    text-align: center;
    font-size: 14px;
    color: #999;
}
    .changeBox{
        position: fixed;
        right: 200px;
        bottom: 200px;
        z-index: 9999;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        background-color: #009BAC;
        color: #fff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0, 0, 0, .7);
        transition: all .1s ease-in-out;
        &:hover{
            transform: scale(1.1);
        }
        span{
            font-size: 24px;
        }
    }
</style>